import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, Input, OnDestroy, ViewChild } from '@angular/core';

@Component({
    standalone: true,
    selector: 'sh-media-placeholder',
    templateUrl: './media-placeholder.component.html',
    styleUrls: ['./media-placeholder.component.scss'],
    imports: [CommonModule]
})
export class ShMediaPlaceholderComponent implements AfterViewInit, OnDestroy {
    private readonly spinnerBaseHeight: number = 4;
    private readonly imageBaseHeight: number = 16;

    private heightObserver?: any;
    private computedHeightPx = 0;

    @Input() source = 'assets/images/placeholders/no-preview-thumb.svg';
    @Input() spinning = false;
    @Input() alt?: string;
    @Input() message?: string;
    @Input() showMessage?: boolean = false;

    @ViewChild('placeholderImage', { static: true }) placeholderImage!: ElementRef<HTMLElement>;
    @ViewChild('spinner') spinner!: ElementRef<HTMLElement>;

    ngAfterViewInit(): void {
        this.heightObserver = new ResizeObserver(([observerEntry]) => {
            if (observerEntry.contentRect?.height !== this.computedHeightPx) {
                this.computedHeightPx = observerEntry.contentRect.height;
                this.spinner.nativeElement.style.height = this.spinnerHeightString;
                this.spinner.nativeElement.style.top = this.spinnerTopString;
            }
        });
        this.heightObserver.observe(this.placeholderImage.nativeElement);
    }

    ngOnDestroy(): void {
        this.heightObserver?.disconnect();
    }

    private convertPixelsToRem(pixels: number): number {
        return pixels / Number.parseFloat(getComputedStyle(document.documentElement).fontSize);
    }

    get computedHeight(): number {
        return this.placeholderImage ? this.convertPixelsToRem(this.computedHeightPx) : 0;
    }

    get spinnerHeight(): number {
        return (this.computedHeight / this.imageBaseHeight) * this.spinnerBaseHeight;
    }

    get spinnerHeightString(): string {
        return `${this.spinnerHeight}rem`;
    }

    // not the same as top: 70% I guess
    get spinnerTopString(): string {
        return `${this.computedHeight * 0.7}rem`;
    }

    get spinnerStyleString(): string {
        return this.spinnerHeightString && this.spinnerTopString
            ? [this.spinnerHeightString, this.spinnerTopString].join('; ')
            : '';
    }
}
